import React, { useEffect, useState } from 'react';
import { MuiColorInput } from 'mui-color-input'
import { Select, MenuItem } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

function ColorInput(props) {
  const onColorChangedFunc = props.onColorChanged;
  const onWeightChangedFunc = props.onWeightChanged;
  const [value, setColor] = useState('#000000');
  const [weight, setWeight] = useState(3);

  function handleColorChange(newValue) {
    setColor(newValue)
    if (onColorChangedFunc)
      onColorChangedFunc(newValue);
  }

  function handleWeightChange(event) {
    const newValue = event.target.value; // Extract the value from the event object
    setWeight(newValue)
    if (onWeightChangedFunc)
      onWeightChangedFunc(newValue);
  }

  return <div>
    Press space to fill area with the selected color

    <MuiColorInput format="hex" value={value} onChange={handleColorChange} />

    <Select
    labelId="select-draw-weight"
    id="select-weight"
    value={weight}
    label="Thickness"
    onChange={handleWeightChange}
  >
    <MenuItem value={1}>1</MenuItem>
    <MenuItem value={2}>2</MenuItem>
    <MenuItem value={3}>3</MenuItem>
    <MenuItem value={4}>4</MenuItem>
    <MenuItem value={5}>5</MenuItem>
  </Select>
  </div>;
}

export default ColorInput;